var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("hb-section", { staticClass: "profile-header" }, [
    _c(
      "div",
      { staticClass: "profile-header__row" },
      [
        _c("b-avatar", {
          attrs: { text: _vm.initials, size: "56", variant: "light-primary" },
        }),
        _c("div", { staticClass: "profile-header__identity" }, [
          _c(
            "div",
            { staticClass: "profile-header__name-row" },
            [
              _c("h2", { staticClass: "profile-header__name" }, [
                _vm._v(_vm._s(_vm.profile.name)),
              ]),
              _vm.isVerified
                ? _c(
                    "b-badge",
                    { attrs: { variant: "light-success", pill: "" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("influencer_panel.verified")) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.profile.level
                ? _c(
                    "b-badge",
                    {
                      attrs: {
                        variant:
                          "light-" +
                          (_vm.profile.level.badge_color || "primary"),
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.profile.level.name) + " "),
                      Number(_vm.profile.level.commission_bonus_pct) > 0
                        ? _c("span", [
                            _vm._v(
                              " · +" +
                                _vm._s(_vm.profile.level.commission_bonus_pct) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.hasLevelBonus
            ? _c(
                "div",
                { staticClass: "profile-header__link-row" },
                [
                  _c("feather-icon", {
                    attrs: { icon: "TrendingUpIcon", size: "14" },
                  }),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("influencer_panel.level_bonus", {
                          pct: _vm.profile.level.commission_bonus_pct,
                        })
                      )
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "profile-header__actions" },
          [
            _c(
              "b-button",
              {
                attrs: { variant: "primary", size: "sm" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("generate-link")
                  },
                },
              },
              [
                _c("feather-icon", {
                  staticClass: "mr-50",
                  attrs: { icon: "Link2Icon", size: "14" },
                }),
                _vm._v(
                  " " + _vm._s(_vm.$t("influencer_panel.generate_link")) + " "
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }